import WDHAccordionSpot from './wdh-accordion-spot';
var wdhAccordionSpot = new WDHAccordionSpot('.accordion-spot:not(.tabs)');
wdhAccordionSpot.run();